import script from "./thumbnail-picker-field.vue?vue&type=script&setup=true&lang=ts"
export * from "./thumbnail-picker-field.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__